import VueNumberFormat from './VueNumberFormat.vue'

export default VueNumberFormat
